module.exports = __webpack_public_path__ + "static/media/cloud-computing.72412fad.svg";